// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import i18n from "i18next";
import { CopyOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { alignRight } from "../../../../utils/Constant";
import TableButton from "../../../components/TableButton";
import { MoreOutlined } from "@ant-design/icons/lib";
import { Button, Popover } from "antd";
import { showConfirm } from "../../../components/ConfirmModal";
import { BroadcastListInfoResponseDTO } from "../../../../api/backend-openapi";
import { navigate } from "@reach/router";
import { ColumnsType } from "antd/lib/table";
import {
  requestDeleteBroadcastList,
  requestDuplicateBroadcastList
} from "../../../../state/broadcastLists/BroadcastListsEffects";

const popoverContent = (
  broadcastList: BroadcastListInfoResponseDTO,
  canDelete: boolean
) => (
  <div className="d-inline-flex">
    <TableButton
      icon={<EyeOutlined />}
      tooltipTitle={i18n.t("broadcast_lists.table.tooltip.view")}
      onClick={() => {
        navigate(`/broadcastLists/${broadcastList.id}`);
      }}
      buttonClassName="btn-primary mr-1 btn-list"
    />
    <TableButton
      icon={<CopyOutlined />}
      tooltipTitle={i18n.t("broadcast_lists.table.tooltip.duplicate")}
      onClick={() => {
        showConfirm(
          i18n.t("broadcast_lists.table.confirmation.duplicate", {
            broadcastList: broadcastList.name
          }),
          () => {
            requestDuplicateBroadcastList({
              id: broadcastList.id
            });
          }
        );
      }}
      buttonClassName="btn-primary mr-1 btn-list"
    />
    {canDelete && (
      <TableButton
        icon={<DeleteOutlined />}
        buttonClassName="btn-danger btn-list"
        onClick={() =>
          showConfirm(
            i18n.t("broadcast_lists.table.confirmation.delete", {
              broadcastList: broadcastList.name
            }),
            () => {
              requestDeleteBroadcastList(broadcastList);
            }
          )
        }
        tooltipTitle={i18n.t("broadcast_lists.table.tooltip.delete")}
      />
    )}
  </div>
);

export const columns = (
  canDelete: boolean
): ColumnsType<BroadcastListInfoResponseDTO> => [
  {
    title: i18n.t("broadcast_lists.table.name"),
    key: "name",
    dataIndex: "name",
    ellipsis: false,
    sorter: true,
    defaultSortOrder: undefined
  },
  {
    title: i18n.t("broadcast_lists.table.action"),
    key: "action",
    fixed: alignRight,
    width: "9%",
    onCell: () => {
      return {
        onClick: (e: any) => e.stopPropagation()
      };
    },
    render: (broadcastList: BroadcastListInfoResponseDTO) => (
      <Popover
        content={popoverContent(broadcastList, canDelete)}
        placement="bottomRight"
        trigger="hover"
      >
        <Button
          icon={<MoreOutlined />}
          type="text"
          size="large"
          className="btn-list"
        />
      </Popover>
    )
  }
];
